import React, { useState, useEffect } from 'react';
import { axiosV2 } from '../../../utils/BasicAuthAPI';
import moment from "moment";
import "../audit.css";
import { Spin, Modal, Form, Input, Select, DatePicker, Button, message, Typography, Col, Row, Tree, Switch, Table, Pagination } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import queryString from "query-string";
import { useParams, useLocation } from "react-router-dom";
import { DownSquareOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

const AddTask = (props) => {

    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [AuditSubType, setAuditSubType] = useState([]);
    // const [ClauseData, setClauseData] = useState({ loaded: false, data: null })
    const [form] = Form.useForm();
    const [loginError, setLoginError] = useState(false);

    const [state, setState] = useState({
        visible: false,
        disabledBtn: false,
    })

    const onFinish = (values) => {
        setState({ ...state, disabledBtn: true });
        let postData = { ...values, "tgtDt": values["tgtDt"] ? values["tgtDt"].format("YYYY/MM/DD") : null, "source": "UI", "initor": "UID_001", "closeDt": null, "link": props.ClauseData["data"]["_id"] }
        
        axiosV2.post('task', postData).then(({ data }) => {
            const msg = data["Message"] ? data["Message"] : "Successfully Added!";
            message.success(msg, 4)
            setState({ ...state, disabledBtn: false });
            form.resetFields();
            props.sendBackData(postData);

        }).catch(function (error) {
            message.error("ERROR: Unable to add!!", 2);
            console.log("Error****: fetch calendar", error);
            setState({ ...state, disabledBtn: false });
            if(error.response!==undefined)
        {
            if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }

        }
        });
    }

    const fetchSubType = () => {
        const typ = form.getFieldValue("TYP");
        form.setFieldsValue({ ...form.getFieldsValue(["TYP", "LID", "cat", "Task", "resp", "tgtDt", "remrkOpen"]), "SUBTYP": null })
        axiosV2.get('mdict', {
            params: {
                typ: "AuditTypes",
                subTyp: "TreeData",
                queryKey: typ
            }
        }).then(({ data }) => {

            const subTyp = data["Data"][typ] ? data["Data"][typ] : [];
            setAuditSubType(subTyp);
        }).catch(function (error) {
            console.log("Error****: fetch subtype", error);
            if(error.response!==undefined)
        {
            if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }

        }
        });
    }


    // useEffect(() => {
    //     console.log("mm", dataLoading.loaded, dataLoading.loading, dataLoading);
    //     if (!dataLoading.loaded && !dataLoading.loading) {
    //         console.log("dasds", dataLoading.loaded, dataLoading.loading, { ...dataLoading, loading: true })
    //         setDataLoading({ ...dataLoading, loading: true });
    //         fetchLine();
    //     }

    // }, [dataLoading.loading])
    

    return (
        <>
        <SessionError visible={loginError} />
        <div className='AuditSection CreateTask' >
            <div >
                {props.loaded ?
                    <>
                        <Row justify="space-around" gutter={24} align="middle">
                            <Col span={24}>
                                <h4 className={"title textCenter"}>Add Task</h4>
                            </Col>
                            <Col span={24}>
                                <div className="ThemeForm">
                                    <Form
                                        form={form}
                                        name="taskForm"
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                        layout="horizontal"
                                        colon={false}
                                        onFinish={onFinish}
                                        size="large"
                                    >
                                        <Row gutter={24} justify="space-around" align="middle">
                                            <Col span={24}>

                                                <Form.Item
                                                    name="LID"
                                                    label="Line"
                                                    rules={[
                                                        { required: true, message: "Please select a Line" },
                                                    ]}
                                                >
                                                    <Select placeholder="Please select a line">
                                                        {
                                                            props.AuditLines.map((obj) =>
                                                                <Select.Option key={"status_" + obj.id} value={obj.id}>
                                                                    {obj.name}
                                                                </Select.Option>
                                                            )
                                                        }
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    name="cat"
                                                    label="Category"
                                                    rules={[
                                                        { required: true, message: "Please select a Category" },
                                                    ]}
                                                >
                                                    <Select placeholder="Please select a Category">
                                                        <Select.Option key={"status_Audit"} value="Audit">Audit</Select.Option>
                                                        <Select.Option key={"status_DWM"} value="DWM">DWM</Select.Option>
                                                        <Select.Option key={"status_Department"} value="Department">Department</Select.Option>
                                                        <Select.Option key={"status_CustomerCompliant"} value="Customer Compliant">Customer Compliant</Select.Option>
                                                        <Select.Option key={"status_MorningMeeting"} value="Morning Meeting">Morning Meeting</Select.Option>
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    name="TYP"
                                                    label="Type"
                                                    rules={[
                                                        { required: true, message: "Please select a type" },
                                                    ]}
                                                >
                                                    <Select placeholder="Please select a type" onChange={fetchSubType}>
                                                        {
                                                            props.AuditType.map((obj) =>
                                                                <Select.Option key={"status_" + obj.id} value={obj.id}>
                                                                    {obj.name}
                                                                </Select.Option>
                                                            )
                                                        }
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    name="SUBTYP"
                                                    label="Sub-Type"
                                                    rules={[
                                                        { required: true, message: "Please select a sub-type" },
                                                    ]}
                                                >
                                                    <Select placeholder="Please select a sub-type">
                                                        {
                                                            AuditSubType.map((obj) =>
                                                                <Select.Option key={"status_" + obj._id} value={obj._id}>
                                                                    {obj.SUBTYP}
                                                                </Select.Option>
                                                            )
                                                        }
                                                    </Select>
                                                </Form.Item>



                                                <Form.Item
                                                    name="Task"
                                                    label="Task"
                                                    rules={[
                                                        { required: true, message: "Please input Task" },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    name="resp"
                                                    label="Responsibility"
                                                    rules={[
                                                        { required: true, message: "Please select a Responsibility" },
                                                    ]}
                                                >
                                                    <Select placeholder="Please select a Responsibility">
                                                        {
                                                            props.AuditUsers.map((obj) =>
                                                                <Select.Option key={"status_" + obj.id} value={obj.id}>
                                                                    {obj.name}
                                                                </Select.Option>
                                                            )
                                                        }
                                                    </Select>
                                                </Form.Item>



                                                <Form.Item
                                                    name="tgtDt"
                                                    label="Target Date"
                                                    placeholder="Select a Target Date"
                                                    rules={[{ required: true }]}
                                                >
                                                    <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select a Target Date" />
                                                </Form.Item>

                                                <Form.Item
                                                    name="remrkOpen"
                                                    label="Opening Remark"
                                                    rules={[
                                                        { required: true, message: "Please input Opening Remark" },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>


                                            </Col>

                                            <div className={"usermanagement textCenter"} style={{ marginTop: "30px" }}>
                                                <Button style={{ textAlign: "center" }} type="primary" htmlType="submit" className="login-form-button gx-mt-1 bigBtn"
                                                    disabled={
                                                        state.disabledBtn
                                                    }
                                                >
                                                    {"Submit"}
                                                </Button>
                                            </div>

                                        </Row>

                                    </Form>
                                </div>
                            </Col>

                        </Row>

                        {/* <div className={"usermanagement textCenter"} style={{ marginTop: "30px" }}>
                            <Link to={`/audit-list`} className="nextBtn">
                                <Button type="danger" htmlType="button" className="login-form-button gx-mt-1 bigBtn">
                                    <span className="gx-link"> Back to Audit Session</span>
                                </Button>
                            </Link>
                        </div> */}
                    </>
                    : <div className="Loading">
                        <Spin indicator={antIcon} tip="Loading..." />
                    </div>}
            </div>
        </div>
    </>
    );


}

export default AddTask;